export enum PwaUpdateAction {
  AFTER_RELOAD,
  FORCE_RELOAD,
  INFORM,
  ASK,
}
